import type { LayoutEntity } from './LayoutEntity'

export class ChannelLayoutEntity {
  id?: number
  channelId?: number
  layouts?: LayoutEntity[]
}
